<template>
  <RevSkeleton
    v-if="verifiedRefurbishCarouselPending"
    height="188px"
    shape="rectangle"
    width="100%"
  />
  <VerifiedRefurbishedCarousel
    v-else-if="productResponse && verifiedRefurbishCarouselResponse"
    :category-id="productResponse.tracking.categoryId"
    :checkpoints="verifiedRefurbishCarouselResponse"
  />
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'

import VerifiedRefurbishedCarousel from '~/scopes/product-core/components/presentationals/VerifiedRefurbishedCarousel/VerifiedRefurbishedCarousel.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchVerifiedRefurbishCarousel } from '~/scopes/product-core/composables/useFetch/useFetchVerifiedRefurbishCarousel/useFetchVerifiedRefurbishCarousel'

const { data: productResponse } = useFetchProduct()
const {
  data: verifiedRefurbishCarouselResponse,
  pending: verifiedRefurbishCarouselPending,
} = useFetchVerifiedRefurbishCarousel()
</script>
